'use client';
import React from 'react';
import { ArrowRight } from 'lucide-react';

interface TProps {
  heading?: string
  subHeading?: string
  buttonText?: string
  buttonLink?: string
}

const SecondaryCTA = ({
  heading = "Ready to Host Your Next Event?",
  subHeading = "Let us help you launch your event within minutes.",
  buttonText = "You Click, We Connect",
  buttonLink = "#hero",
}: TProps) => {
  return (
    <section className="bg-white py-24">
      <div className="mx-auto max-w-4xl px-4 text-center sm:px-6 lg:px-8">
        <h2 className="text-4xl font-extrabold text-gray-900 sm:text-5xl lg:text-6xl leading-11 sm:leading-12 md:leading-16">
          {heading}
        </h2>
        <p className="mx-auto mt-2 max-w-2xl text-xl text-gray-500">
          {subHeading}
        </p>

        <div className="mt-10 flex justify-center">
          <a href={buttonLink} className="group relative inline-flex items-center justify-center overflow-hidden rounded-full bg-primary px-8 py-4 text-lg font-bold text-white shadow-xl transition-all duration-300 hover:bg-primary/90 hover:scale-105 hover:shadow-2xl focus:outline-none focus:ring-2 focus:ring-primary focus:ring-offset-2">
            <span className="relative z-10 flex items-center">
              {buttonText}
              <ArrowRight className="ml-2 h-5 w-5 transition-transform duration-300 group-hover:translate-x-1" />
            </span>
            <div className="absolute inset-0 -z-0 bg-gradient-to-r from-primary via-white/20 to-primary opacity-0 transition-opacity duration-300 group-hover:opacity-20" />
          </a>
        </div>
      </div>
    </section>
  );
};

export default SecondaryCTA;